import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  children: PropTypes.node.isRequired,
  isCurrentPage: PropTypes.bool,
  isDisabled: PropTypes.bool,
  labelText: PropTypes.string,
  onClick: PropTypes.func
};
function PageButton(_ref) {
  var children = _ref.children,
    isCurrentPage = _ref.isCurrentPage,
    isDisabled = _ref.isDisabled,
    labelText = _ref.labelText,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default.createElement("button", {
    "aria-current": isCurrentPage ? 'page' : null,
    "aria-label": labelText,
    disabled: isDisabled,
    onClick: onClick,
    type: "button"
  }, children);
}
PageButton.propTypes = propTypes;

export { PageButton as default };
//# sourceMappingURL=PageButton.js.map
